module.exports = __webpack_public_path__ + "static/img/cha6-bg.f98a237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha6-bg.png
// module id = cF73
// module chunks = 1